import { gql } from '@apollo/client';

export const GET_CHECKCLASSROOMHOMEWORK = gql`
  query SkWeb_ClassroomList_CheckHomework(
    $schoolId: ID
    $name: String
    $page: Int
    $pageSize: Int
  ) {
    classroomList(
      schoolId: $schoolId
      name: $name
      page: $page
      pageSize: $pageSize
    ) {
      data {
        id
        name
        school {
          id
          name
        }
        teachers {
          id
          name
          username
        }
        courses {
          level
          product {
            id
            name
          }
        }
        studentsLength
        undoneHomeworks
      }
      totalCount
    }
  }
`;
